import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

import api from 'services';

class CheckTokenPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: '',
            errors: '',
            token: null,
        };

        this.checkToken = this.checkToken.bind(this);
        this.onChangeToken = this.onChangeToken.bind(this);
    }

    onChangeToken(e, value) {
        this.setState({
            text: value,
            errors: '',
        });
    }

    checkToken() {
        api.checkToken({
            token: this.state.text,
        })
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        token: response.data.data,
                    })
                }
            })
            .catch((error) => {
                console.error('check token', error);

                this.setState({
                    errors: error.response.data.errors[0].messages[0],
                })
            });
    }

    render() {
        const { token, text, errors } = this.state;

        return (
            <div id='token-check' className='container'>
                <div className="row">
                    <div className="col-xs-6">
                        <div className="row">
                            <div className="col-xs-12">
                                <TextField
                                    errorText={errors}
                                    name='token'
                                    floatingLabelText="Token put here"
                                    multiLine
                                    fullWidth
                                    rows={4}
                                    rowsMax={99}
                                    value={text}
                                    onChange={this.onChangeToken}>
                                </TextField>
                            </div>
                            <div className="col-xs-12">
                                <RaisedButton
                                    label='check'
                                    onClick={this.checkToken}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-6">
                        <pre>
                            { token ? JSON.stringify(token, null, 2) : '' }
                        </pre>
                    </div>
                </div>
            </div>
        );
    }
}

CheckTokenPage.defaultProps = {
    isLoaded: false,
};

CheckTokenPage.propTypes = {
    isLoaded: PropTypes.bool,
};

export default connect(
    ({ user: { isLogged }}) => {
        return {
            isLogged,
        };
    },
    dispatch => bindActionCreators({
        },
        dispatch),
)(CheckTokenPage);



// WEBPACK FOOTER //
// ./app/components/Tokens/CheckToken/Page.jsx